import moment from 'moment'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/fr'

dayjs.locale('fr')

export interface DateData {
    isOverdue: boolean
    day: string
    hour: string
}

export const isInTimeRange = (date: dayjs.Dayjs, from: dayjs.Dayjs, to: dayjs.Dayjs): boolean => {
  return date.isAfter(from) && date.isBefore(to)
}

export const toDayjsDate = (isoDateString: string) => {
    const date = dayjs(isoDateString)
    if (!date.isValid()) {
        throw new Error(`Invalid iso date string provided to dayjs! Passed: ${isoDateString}`)
    }
    return date
}

export const getDaysFromNow = (isoDateString: string) => toDayjsDate(isoDateString).diff(dayjs())

export const getIsDatePast = (isoDateString: string): boolean => toDayjsDate(isoDateString).isBefore(dayjs())

const getDateDisplay = (date: Dayjs) => date.format('DD/MM/YYYY')
export const getDayDisplayFromIso = (isoDateString: string) => getDateDisplay(toDayjsDate(isoDateString))

export const getDateInfo = (isoDateString: string): DateData => {
    const date = toDayjsDate(isoDateString)
    const now = dayjs()
    return {
        isOverdue: date.isBefore(now),
        day: getDateDisplay(date),
        hour: date.format('HH:mm'),
    }
}

export const getDateInfoDayOnly = (isoDateString: string): DateData => {
    const date = toDayjsDate(isoDateString)
    const now = dayjs()
    const isOverdue = date.startOf('day').isBefore(now.startOf('day'))

    return {
        isOverdue,
        day: getDateDisplay(date),
        hour: date.format('HH:mm'),
    }
}


// TODO remove below functs once not in use
/**
 * @description Return number days between currentDate and date
 * @param {Date} date
 * @returns {Number} number of days between currentDate and date or return -1 if no date
 */
export const calculateDiffBetweenTwoMomentDates = (date: any) => {
    if (date) {
        const currentDate = moment(Date.now(), 'DD/MM/YYYY')
        const dateMomentObject = moment(date, 'DD/MM/YYYY')
        return currentDate.diff(dateMomentObject, 'days')
    }
    return -1
}

/**
 * @description Return number years between currentDate and date
 * @param {Date} date
 * @returns {Number} number of years between currentDate and date or return -1 if no date
 */
export const calculateDiffBetweenTwoMomentDatesInYears = (date: any) => {
    if (date) {
        const currentDate = moment()
        const dateMomentObject = moment(date, 'DD/MM/YYYY')
        return currentDate.diff(dateMomentObject, 'years')
    }
    return -1
}

/**
 * @description check if date is overdue
 * @param {Date} date date to compare
 * @param {Date} dueDate date to compare with. Will be set to today if undefined
 * @returns {boolean | undefined}
 */
export const getIsDateOverdue = (date: any, dueDate = new Date()) => {
    try {
        const formatedDate = moment(date, 'DD/MM/YYYY H:mm')
        const formatedDueDate = moment(dueDate, 'DD/MM/YYYY H:mm')

        const isOverdue = formatedDate.diff(formatedDueDate, 'minutes') < 0

        return isOverdue
    } catch (error) {
        console.log(error)
        return undefined
    }
}

export const getAge = (birthdate?: string | null) => {
    // TODO remove the undefined null, and error throw once api is updated
    if (!birthdate) throw new Error('Patient have no birthdate')
    const birth = dayjs(birthdate)
    const today = dayjs()

    return today.diff(birth, 'year')
}
